import * as React from 'react';
import QuestionnaireComponent from 'components/Questionnaire';
import { connect } from 'react-redux';
import { Error } from '@pec/aion-ui-components/components/Error';
import {
  fetchQuestionnaireSections,
  fetchQuestionnaireSectionsIfNeeded
} from '@pec/aion-ui-core/actions/questionnaireSections';
import { fetchRankings } from '@pec/aion-ui-core/actions/rankings';
import { getOptionsIfNeeded, setOption } from '@pec/aion-ui-core/actions/options';
import { History } from 'history';
import { Loading } from '@pec/aion-ui-components/components/Loading';
import { RootActions } from 'combineActions';
import { RootState } from 'combineReducers';
import { ThunkDispatch } from 'redux-thunk';
import { RouteComponentProps, withRouter } from 'react-router';
import { filterQuestionnaireSections } from 'helpers/helpers';

type RouteParams = {
  organizationId: string;
};

type OwnProps = {
  match: {
    params: {
      organizationId: string;
      questionnaireSectionId: string;
    };
  };
  history: History;
  isEnabled?: boolean;
};

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
  const { questionnaireSections, error } = state.questionnaireSections;
  const {
    match: {
      params: { questionnaireSectionId }
    },
    isEnabled
  } = ownProps;
  const questionnaireSectionsRemaining = filterQuestionnaireSections(questionnaireSections, isEnabled);

  return {
    questionnaireSections: questionnaireSectionsRemaining,
    activeSection: questionnaireSectionsRemaining?.find(q => q.id === +questionnaireSectionId),
    error
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<RootState, null, RootActions>,
  {
    match: {
      params: { organizationId, questionnaireSectionId }
    }
  }: OwnProps
) => ({
  fetchQuestionnaireSectionsIfNeeded: () => dispatch(fetchQuestionnaireSectionsIfNeeded(organizationId)),
  fetchQuestionnaireSections: () => dispatch(fetchQuestionnaireSections(organizationId)),
  fetchRankings: () => dispatch(fetchRankings(organizationId)),
  getOptionsIfNeeded: () => dispatch(getOptionsIfNeeded()),
  setQuestionnaireLastViewedSectionId: () =>
    dispatch(setOption('questionnaireLastViewedSectionId', questionnaireSectionId))
});

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  RouteComponentProps<RouteParams> &
  OwnProps;

class Questionnaire extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    props.setQuestionnaireLastViewedSectionId();
    props.fetchQuestionnaireSectionsIfNeeded();
    props.getOptionsIfNeeded();
  }

  componentDidUpdate() {
    this.redirectToCompanyDashboard();
  }

  redirectToCompanyDashboard() {
    const {
      isEnabled,
      questionnaireSections,
      history,
      match: {
        params: { organizationId, questionnaireSectionId }
      }
    } = this.props;
    const sectionIDsToCheck = ['1', '2', '3', '224'];

    // Note: redirect to company dashboard if organization profile feature flag is enabled or no sections available
    if (
      isEnabled &&
      (sectionIDsToCheck.includes(questionnaireSectionId) ||
        (Array.isArray(questionnaireSections) && questionnaireSections.length === 0))
    ) {
      history.replace(`/${organizationId}`);
    }
  }

  render() {
    const {
      questionnaireSections,
      activeSection,
      error,
      match: {
        params: { organizationId }
      },
      history
    } = this.props;

    return activeSection ? (
      <QuestionnaireComponent
        questionnaireSections={questionnaireSections}
        activeSection={activeSection}
        organizationId={organizationId}
        fetchQuestionnaireSections={this.props.fetchQuestionnaireSections}
        fetchRankings={this.props.fetchRankings}
        history={history}
      />
    ) : error ? (
      <Error />
    ) : (
      <Loading />
    );
  }
}

export const QuestionnaireContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(Questionnaire));
